function createInfiniteScroll() {
	const containers = document.querySelectorAll('.container');
	containers.forEach(container => {
		const logos = container.querySelectorAll('.logo');
		const cloneLogos = [...logos].map(logo => logo.cloneNode(true));
		cloneLogos.forEach(logo => container.appendChild(logo));

		let scrollAmount = 0.5;
		const speed = 1; // Adjust scrolling speed as needed
		function scroll() {
			scrollAmount += speed;
			container.scrollLeft = scrollAmount;
			if (scrollAmount >= container.scrollWidth / 2) {
				container.scrollLeft = 0;
				scrollAmount = 0;
			}
			requestAnimationFrame(scroll);
		}
		scroll();
	})
}

// Wait for images to load before starting the scrolling
window.addEventListener('load', createInfiniteScroll);
